import { render, staticRenderFns } from "./WidgetDialog.vue?vue&type=template&id=7283d4e7"
import script from "./WidgetDialog.vue?vue&type=script&lang=js"
export * from "./WidgetDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports